
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AddTestimonials = () => {
  const [testimonial, setTestimonial] = useState({
    name: '',
    role: '',
    description: ''
  });
  const [image, setImage] = useState(null);
  const [bannerImage, setBannerImage] = useState(null); // New banner image state


  const [testimonials, setTestimonials] = useState([]);
  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleChange = (e) => {
    setTestimonial({
      ...testimonial,
      [e.target.name]: e.target.value
    });
  };
  const handleBannerChange = (e) => {
    setBannerImage(e.target.files[0]); // New handler
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('name', testimonial.name);
      formData.append('role', testimonial.role);
      formData.append('description', testimonial.description);
      if (image) formData.append('image', image);
      if (bannerImage) formData.append('bannerImage', bannerImage); // New line


      await axios.post('https://blog-backend-ivfv.onrender.com/testimonials', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      alert('Testimonial added successfully!');
      setTestimonial({ name: '', role: '', description: '' });
      setImage(null);
      fetchTestimonials();
    } catch (error) {
      console.error(error);
      alert('Failed to add testimonial');
    }
  };


  const fetchTestimonials = async () => {
    try {
      const response = await axios.get('https://blog-backend-ivfv.onrender.com/testimonials');
      setTestimonials(response.data);
    } catch (error) {
      console.error(error);
      alert('Failed to fetch testimonials');
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);
  const toggleStatus = async (id, currentStatus) => {
    try {
      await axios.patch(`https://blog-backend-ivfv.onrender.com/testimonials/${id}/disable`, {
        isActive: !currentStatus
      });
      fetchTestimonials();
    } catch (error) {
      console.error(error);
      alert('Failed to update status');
    }
  };

  return (
    <div className="container mt-4">
      <h3>Add Testimonial</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Image</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Banner Image</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleBannerChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={testimonial.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Role</label>
          <input
            type="text"
            className="form-control"
            name="role"
            value={testimonial.role}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            name="description"
            value={testimonial.description}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">Add Testimonial</button>
      </form>

      <hr className="my-5" />

      <h4>Testimonials</h4>
      <div className="container">
        <div className="row">
          {testimonials.map((t) => (
            <div className="col-md-6 col-lg-4 mb-4" key={t._id}>
              <div className="card h-100 border-0 shadow-sm testimonial-card hover-shadow">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center"
                      style={{ width: '40px', height: '40px', fontSize: '18px' }}
                    >
                      {t.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="ms-3">
                      <h5 className="card-title mb-0">{t.name}</h5>
                      <span className="badge bg-secondary">{t.role}</span>
                    </div>
                  </div>

                  {/* Testimonial Image */}
                  {t.image && (
                    <img
                      src={`https://blog-backend-ivfv.onrender.com${t.image}`}
                      alt={t.name}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "6px",
                        marginBottom: "1rem",
                      }}
                    />
                  )}

                  <p className="card-text text-muted">"{t.description}"</p>
                </div>

                {/* Footer */}
                <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    Posted on: {new Date(t.createdAt).toLocaleString()}
                  </small>
                  <button
                    className={`btn btn-sm ${t.isActive ? 'btn-danger' : 'btn-success'}`}
                    onClick={() => toggleStatus(t._id, t.isActive)}
                    aria-pressed={t.isActive}
                    aria-label={t.isActive ? `Disable testimonial by ${t.name}` : `Enable testimonial by ${t.name}`}
                  >
                    {t.isActive ? 'Disable' : 'Enable'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>




    </div>
  );
};

export default AddTestimonials;
